import { render } from "./App.vue?vue&type=template&id=cd1ca722"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=cd1ca722&lang=stylus"
script.render = render

export default script